import { useCallback, useState } from "react";

import { clsx } from "clsx";
import { observer } from "mobx-react-lite";
import { Link, useLocation } from "react-router-dom";

import iDemosActive from "../../assets/images/100-demos-active.svg";
import iDemos from "../../assets/images/100-demos.svg";
import iWorkspacesActive from "../../assets/images/100-workspaces-active.svg";
import iWorkspaces from "../../assets/images/100-workspaces.svg";
import Logo from "../../assets/images/Logo-echoed.svg";
import { useAuth } from "../../contexts/authContext";
import { useJanusContext } from "../../contexts/janus/JanusContext";
import { useMeetingDetailsStore } from "../../contexts/meetingDetails/meetingDetailsContext";
import { useApi } from "../../hooks/useApi";

const MenuItem = ({ to, src, name }) => {
  const location = useLocation();
  return (
    <Link
      to={to}
      className={clsx({
        "menu-item": true,
        "menu__item-box--enable": location.pathname.includes(to),
      })}>
      <div
        className={clsx({
          "menu-item__box--disable": !location.pathname.includes(to),
        })}>
        {src}
      </div>
      <span
        className={clsx({
          "menu-item__title--disable B3-SemiBold": !location.pathname.includes(to),
          "menu-item__title--enable B3-SemiBold": location.pathname.includes(to),
        })}>
        {name}
      </span>
    </Link>
  );
};

const SideMenu = () => {
  const contextStore = useMeetingDetailsStore();
  const location = useLocation();
  const { setJanusConfig } = useJanusContext();

  const { sendCurrentUserEvent } = useApi();
  const { userData } = useAuth();

  const currUserPid = contextStore?.participants && contextStore.participants.find((participant) => participant.user.uid === userData.uid)?.pid;

  const [loadingPage, setLoadingPage] = useState(true);

  setTimeout(() => {
    setLoadingPage(false);
  }, 1000);

  const handleJoinJanus = useCallback(() => {
    setJanusConfig(contextStore.janusConfig);
    console.log(JSON.stringify(contextStore.janusConfig));
  }, []);

  const handleJoinJanusForSecondUser = useCallback(() => {
    const HARDCODED_JANUS_CONFIG =
      '{"server":"wss://v191.lab.sgigs.com:8989/ws","token":"","screenStreamIds":{"101":101,"102":102},"videoRoom":{"room":1234,"secret":"adminpwd","pin":"","host":"127.0.0.1","host_family":"ipv4","video_port": "8010","streams":[{"host":"127.0.0.1","mid":"1","port":6000,"simulcast":false,"pt":96},{"host":"s151","mid":"0","port":6002,"simulcast":false,"pt":111},{"host":"127.0.0.1","mid":"2","port":6004,"simulcast":false}]}}';
    setJanusConfig(JSON.parse(HARDCODED_JANUS_CONFIG));
  }, []);

  return (
    <aside className="side-menu">
      <div>
        {loadingPage ? (
          <div className="loading-side-menu">
            <div className="loading-68-68-15 loading-animation" />
            <div className="loading-68-68-15 loading-animation" />
            <div className="loading-68-68-15 loading-animation" />
          </div>
        ) : (
          <div className="side-menu__menu">
            <div className="logo-container">
              <img src={Logo} alt="logo" width="74px" />
            </div>
            <MenuItem
              to="/live"
              src={location.pathname.includes("/live") ? <img src={iWorkspacesActive} alt="" /> : <img src={iWorkspaces} alt="" />}
              name="Meeting"
            />
            <MenuItem
              to="/course"
              src={location.pathname.includes("/course") ? <img src={iDemosActive} alt="" /> : <img src={iDemos} alt="" />}
              name="Course"
            />
            8010
            <div style={{ width: "100%", display: "flex", flexDirection: "column", gap: "4px" }}>
              <p style={{ textAlign: "center" }}>MobX debug menu</p>
              <hr />
              <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={() => window.location.reload()}>
                Reload Browser
              </button>
              <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={contextStore.clearPersistedData}>
                Clear Store Persist
              </button>
              <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={contextStore.pausePersist}>
                Pause Store Persist
              </button>
              <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={contextStore.startPersist}>
                Restart Store Persist
              </button>
              <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={contextStore.rehydrateStore}>
                Hydrate Store
              </button>
              <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={contextStore.getPersistedData}>
                Get Store Persist
              </button>
              <hr />
              {!!contextStore.meeting && (
                <>
                  <p style={{ textAlign: "center" }}>User join debug menu</p>
                  <hr />
                  <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={handleJoinJanus}>
                    Join Janus
                  </button>
                  <button style={{ fontSize: "12px" }} className="button button-lg button-bk button-r" onClick={handleJoinJanusForSecondUser}>
                    Join Janus 2nd user
                  </button>
                  <button
                    style={{ fontSize: "12px" }}
                    className="button button-lg button-bk button-r"
                    onClick={() => sendCurrentUserEvent({ lwid: contextStore.meeting?.mid, pid: currUserPid, data: { status: "joining" } })}>
                    Join progress +1
                  </button>
                  <button
                    style={{ fontSize: "12px" }}
                    className="button button-lg button-bk button-r"
                    onClick={() => sendCurrentUserEvent({ lwid: contextStore.meeting?.mid, pid: currUserPid, data: { status: "joined" } })}>
                    Join complete
                  </button>
                  <p style={{ textAlign: "center" }}>JP-{Math.round((100 / contextStore.joinProgressLength) * contextStore.joinProgress)}%</p>
                  <hr />
                  <p style={{ textAlign: "center" }}>User leave debug menu</p>
                  <hr />
                  {/* <button
                    style={{ fontSize: "12px" }}
                    className="button button-lg button-bk button-r"
                    onClick={() =>
                      sendCurrentUserEvent({
                        lwid: contextStore.meeting?.mid,
                        pid: currUserPid,
                        data: JSON.stringify({ status: "leave-janus" }),
                      })
                    }>
                    Send leave-janus
                  </button> */}
                  <button
                    style={{ fontSize: "12px" }}
                    className="button button-lg button-bk button-r"
                    onClick={() => sendCurrentUserEvent({ lwid: contextStore.meeting?.mid, pid: currUserPid, data: { status: "leaving" } })}>
                    Leave progress +1
                  </button>
                  <button
                    style={{ fontSize: "12px" }}
                    className="button button-lg button-bk button-r"
                    onClick={() => sendCurrentUserEvent({ lwid: contextStore.meeting?.mid, pid: currUserPid, data: { status: "left" } })}>
                    Leave complete
                  </button>
                </>
              )}
            </div>
          </div>
        )}
      </div>
    </aside>
  );
};

export default observer(SideMenu);
